exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.newGrid[data-v-0595ff32] {\n\theight: 100%;\n\tdisplay: grid;\n}\n.newsCategory[data-v-0595ff32] {\n\tgrid-area: category;\n}\n.newsSearch[data-v-0595ff32] {\n\tgrid-area: search;\n}\n.newsFiltersGrid[data-v-0595ff32] {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr 1fr;\n\tgrid-template-areas: 'category search search';\n}\n.imgNews[data-v-0595ff32] {\n\tmax-height: 200px;\n}\n@media (max-width: 768px) {\n.newsFiltersGrid[data-v-0595ff32] {\n\t\tdisplay: block;\n}\n.newsFiltersGrid div[data-v-0595ff32] {\n\t\tmargin: 5px;\n}\n}\n", ""]);

// exports
